import styled from "styled-components";
import { device } from "../../../style";

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-bottom: 62px;
  @media ${device.laptop} {
    flex-direction: row;
    margin-bottom: 0px;
  }
`;

export const LeftSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  //flex: 1 1 60%;
`;

export const RightSection = styled.div`
  min-width: 250px;
  width: 100%;
  flex: 1 1 min-content;
`;
